import React from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import { createStore, applyMiddleware, compose } from "redux";
import reduxThunk from "redux-thunk";
import reducers from "./reducers";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

const Root = ({ children, initialState = {} }) => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  let middleware = [reduxThunk];
  middleware.push(require("redux-logger").createLogger());

  const store = createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
  );

  // if (process.env.REACT_APP_NO_PERSIST) {
  //     console.log('DISABLE PERSIST')
  //     return <Provider store={store}>{children}</Provider>;
  // }

  let persistor = persistStore(store);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
};

Root.propTypes = {
  children: PropTypes.object,
  initialState: PropTypes.object,
};

export default Root;
